import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function CartNote() {
    const { t } = useTranslation('cart');
    return (
        <Wrapper>
            <Text color={colors.gray6}>
                {t('note.message')}
            </Text>
        </Wrapper>
    );
}

const Wrapper = styled.aside`
    background-color: var(--color-gray2);
    border-radius: 8px;
    margin: 20px 20px 42px;
    padding: 12px;
    width: calc(100% - 40px);
`;

export default CartNote;
